import React from "react";
import { motion } from "framer-motion";

export const RaceInfo = ({ categoryName }) => {
  const trimmedCategoryName = categoryName ? categoryName.trim() : "";

  const qualifications = {
    "Vertical (7K)": ["Kategori ini hanya untuk Atlet ALTI DKI Jakarta"],
    "Fun Trail (7K)": [
      "Telah menyelesaikan setidaknya satu lomba 5 km road dalam satu tahun terakhir",
    ],
    "Classic Distance (20K)": [
      "Telah menyelesaikan setidaknya satu lomba 21 km road (Half Marathon) dalam satu tahun terakhir; atau",
      "Memiliki pengalaman lomba trail running minimal 10K",
    ],
    "Short Distance (40K)": [
      "Telah menyelesaikan setidaknya satu lomba 42 km road (Full Marathon) dalam satu tahun terakhir; atau",
      "Memiliki pengalaman lomba trail running minimal 20K",
    ],
    "Long Distance (80 K)": [
      "Telah menyelesaikan setidaknya satu lomba 42 km road (Full Marathon) dalam satu tahun terakhir; atau",
      "Memiliki pengalaman lomba trail running minimal 40K",
    ],
    "Mix Group (20K)": [
      "Setiap anggota group setidaknya telah menyelesaikan satu lomba 21 km road (Half Marathon) dalam satu tahun terakhir; atau",
      "Setiap anggota group memiliki pengalaman lomba trail running minimal 10K dalam tiga tahun terakhir",
    ],
  };

  const raceInclusions = {
    "Vertical (7K)": [
      "Nomor BIB",
      "Medali Finisher",
      "Jersey Finisher",
      "Race Jersey",
    ],
    "Fun Trail (7K)": ["Nomor BIB", "Medali Finisher", "Race Jersey"],
    "Classic Distance (20K)": [
      "Nomor BIB",
      "Medali Finisher",
      "Jersey Finisher",
      "Race Jersey",
    ],
    "Short Distance (40K)": [
      "Nomor BIB",
      "Medali Finisher",
      "Jersey Finisher",
      "Race Jersey",
    ],
    "Long Distance (80 K)": [
      "Nomor BIB",
      "Medali Finisher",
      "Jersey Finisher",
      "Race Jersey",
    ],
    "Mix Group (20K)": [
      "Nomor BIB",
      "Medali Finisher",
      "Jersey Finisher",
      "Race Jersey",
    ],
  };

  const qualificationList = qualifications[trimmedCategoryName];
  const inclusionList = raceInclusions[trimmedCategoryName];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 mb-8">
      {/* Existing Qualification and Race Inclusions Container */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {/* Kolom Kualifikasi (Kiri) */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h3 className="text-xl font-bold text-lime-600 mb-4">
            Qualification
          </h3>
          <ul className="list-disc list-inside text-gray-700">
            {qualificationList && qualificationList.length > 0 ? (
              qualificationList.map((item, index) => (
                <li key={index} className="text-sm mb-2">
                  {item}
                </li>
              ))
            ) : (
              <li className="text-sm mb-2">
                Tidak ada kualifikasi spesifik untuk kategori ini. Silakan
                periksa data kategori.
              </li>
            )}
          </ul>
        </motion.div>

        {/* Kolom Inklusi Perlombaan (Kanan) */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3 className="text-xl font-bold text-lime-600 mb-4">
            Race Inclusions
          </h3>
          <ul className="list-disc list-inside text-gray-700">
            {inclusionList && inclusionList.length > 0 ? (
              inclusionList.map((item, index) => (
                <li key={index} className="text-sm mb-2">
                  {item}
                </li>
              ))
            ) : (
              <li className="text-sm mb-2">
                Tidak ada informasi inklusi tersedia untuk kategori ini. Silakan
                periksa data kategori.
              </li>
            )}
          </ul>
        </motion.div>
      </div>

      {/* New Container for Images (No Border) */}
      <div className="bg-white rounded-xl p-4">
        <div className="flex flex-col md:flex-row justify-center md:gap-10 items-center">
          {/* Jersey Image (Left) */}
          <motion.div
            className="flex justify-center md:justify-end"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img
              src="/images/jersey.png"
              alt="Event Jersey"
              className="h-auto max-h-[300px] object-contain rounded-lg"
            />
          </motion.div>

          {/* Race Pack Image (Right) */}
          <motion.div
            className="flex justify-center md:justify-start"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <img
              src="/images/racepack.png"
              alt="Race Pack"
              className="h-auto max-h-[300px] object-contain rounded-lg"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};
